import { useSuspenseQuery } from "@tanstack/react-query";
import { type PropsWithChildren, useMemo } from "react";

import { getPrivateSpaceRepositories } from "src/components/PrivateSpaceRepositoryProviders";
import {
  SpaceRepositoryProviders,
  type SpaceRepositories,
} from "src/components/SpaceRepositoryProviders";
import { athleteProfileQueryOptions } from "src/queries/athletes";
import { createPrivatePartnershipProgramsRepository } from "src/repositories/programs/createPrivatePartnershipProgramsRepository";

interface AthleteSpaceRepositoryProvidersProps extends PropsWithChildren {
  athleteId: string;
}

export function AthleteSpaceRepositoryProviders(
  props: AthleteSpaceRepositoryProvidersProps,
) {
  const athleteProfile = useSuspenseQuery(
    athleteProfileQueryOptions(props.athleteId),
  ).data;
  const athlete = athleteProfile.athlete;
  const repositories = useMemo<SpaceRepositories>(() => {
    return {
      ...getPrivateSpaceRepositories(),
      programs: createPrivatePartnershipProgramsRepository({
        athleteId: athlete.id,
        partnershipId: athlete.partnership.id,
      }),
    };
  }, [athlete.id, athlete.partnership.id]);

  return (
    <SpaceRepositoryProviders repositories={repositories}>
      {props.children}
    </SpaceRepositoryProviders>
  );
}
